import { ApiGroup } from "../types/ApiTypes"

/**
 * 1:1 문의 관련 API
 */
const InquiryAPI: ApiGroup = {
    createPublic: {
        title: "공개 문의 등록 (인증 불필요)",
        url: "/Inquiry/Public",
        method: "POST",
        paramz: {},
    },
    pagedList: {
        title: "문의 목록 조회 (관리자)",
        url: "/Inquiry/PagedList",
        method: "POST",
        paramz: {},
    },
    getById: {
        title: "문의 단건 조회",
        url: "/Inquiry/{seqId}",
        method: "GET",
        pathParams: ["seqId"],
        paramz: {},
    },
    updateStatus: {
        title: "문의 상태 변경",
        url: "/Inquiry/{seqId}/Status",
        method: "PATCH",
        pathParams: ["seqId"],
        paramz: {},
    },
}

export default InquiryAPI
